import React, {Component} from 'react'
import {connect} from 'react-redux'
import McpIndexMenuItem from "./McpIndexMenuItem"

class McpIndexMenu extends Component {
    render() {
        return (
            <div className="navbarAuthDiv" style={{minHeight: '100vh', padding: "16px"}}>
                <div style={{marginBottom: "16px"}}>
                    <McpIndexMenuItem
                        name="mcp"
                        icon="plug"
                        displayName="MCP"
                    />
                </div>
                <div style={{marginBottom: "16px"}}>
                    <McpIndexMenuItem
                        name="ai"
                        icon="tasks"
                        displayName="Agents"
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(McpIndexMenu)
